import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=2e80dd6d&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=ts&"
export * from "./AppSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=2e80dd6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80dd6d",
  null
  
)

export default component.exports